import { Injectable } from "../../../../node_modules/@angular/core";
import { ApiService } from "@app/core/services/api.service";
import { map } from "../../../../node_modules/rxjs/operators";

@Injectable()
export class FileService {
    constructor (
        private apiService: ApiService
    ) {}
    downloadPDF(path:string) : any {
        return this.apiService.getPDF(path)
        .pipe(
            map(
              res => {        
                return res
              },
              err => {
                console.log("error response"+ err);
              }
            )
        );
    }
}